import { apiClient } from "./api";

export const userService = {
  async userInAuth(email) {
    //: string
    return apiClient.request("/api/userInAuth", {
      body: { email: email.toLowerCase().replace(/ /g, "") },
      includeStatus: true,
      method: "POST",
    });
  },

  async getUserData(uid) {
    //: string
    return apiClient.request(`/api/users/${uid}`, {
      method: "GET",
      requireAuth: true,
    });
  },

  async setUserData({ uid, ...data }) {
    //: { uid: string; [key: string]: any }
    return apiClient.request(`/api/users/${uid}`, {
      body: data,
      method: "PATCH",
      requireAuth: true,
    });
  },

  async setBootcampTeachableUser(params) {
    //: { email: string; name: string; uid: string }
    return apiClient.request("/api/bootcampTeachableUser", {
      body: params,
      method: "POST",
      requireAuth: true,
    });
  },

  async sendBootcampEmail(params) {
    //: { bootcampUser: boolean; email: string; uid: string }
    return apiClient.request("/api/bootcampEmail", {
      body: params,
      method: "POST",
      requireAuth: true,
    });
  },

  async createSubscription(data) {
    //: CreateSubscriptionI
    return apiClient.request("/api/subscription", {
      body: data,
      method: "POST",
      requireAuth: false,
    });
  },

  async getSubscriptionAddons(data) {
    return apiClient.request("/api/v1/subscription-addons/list", {
      body: data,
      method: "POST",
      requireAuth: true,
    });
  },

  async updateProratedStripeSubscriptionToNormalPriceOnNextBilling(data) {
    //: CreateSubscriptionI
    return apiClient.request("/api/stripeFixProratedSubscriptionPrice", {
      body: data,
      method: "POST",
      requireAuth: false,
    });
  },

  async createPartnerSubscription(data) {
    //: CreatePartnerSubscriptionI
    return apiClient.request("/api/subscription", {
      body: data,
      method: "POST",
      requireAuth: true,
    });
  },

  async getSubscriptionByUser(uid) {
    //: string
    return apiClient.request(`/api/subscriptionByUserId/${uid}`, {
      method: "GET",
      requireAuth: true,
    });
  },

  async cancelCurrentSubscription(email) {
    //: string
    return apiClient.request("/api/cancelSubHelper", {
      body: { email },
      method: "POST",
    });
  },

  async pauseStripeSubByID(id) {
    //: string
    return apiClient.request(`/api/pauseStripeSubByID/${id}`, {
      method: "POST",
      requireAuth: true,
    });
  },

  async userEmailVerf(uid) {
    //: string
    return apiClient.request("/api/userEmailVerf", {
      body: { id: uid, status: true },
      method: "PATCH",
      requireAuth: true,
    });
  },

  async createUserMobile({ data }) {
    //: { data: CreateUserMobileI }
    return apiClient.request("/api/userMobile", {
      body: data,
      method: "POST",
    });
  },

  async updateUserNY({ subscriptionType, uid, role }) {
    //: { subscriptionType: SubscriptionT; uid: string }
    const body = {
      userInfo: {
        subscriptionType,
        ...(role !== undefined ? { role: role } : {}),
      },
    };

    return apiClient.request(`/api/updateUserNY/${uid}`, {
      body: body,
      method: "POST",
      requireAuth: true,
    });
  },

  async setUserReferral(
    params
    //     : {
    //     amount: number
    //     email: string
    //     externalIdentifier: string
    //     firstName: string
    //     lastName: string
    //     note: string
    //     referralCode: string
    //   }
  ) {
    return apiClient.request("/api/referral", {
      body: params,
      method: "POST",
      requireAuth: true,
    });
  },

  async searchUserByEmail({ email }) {
    //: { email: string }
    return apiClient.request("/api/searchUserByEmail", {
      body: { email: email.toLowerCase() },
      method: "POST",
      requireAuth: true,
    });
  },

  verifyStaffEnt(uid) {
    //: string
    return apiClient.request(`/api/verifyStaffEnt/${uid}`, {
      method: "POST",
      requireAuth: true,
    });
  },

  getMobileAppSettings() {
    return apiClient.request("/api/v1/mobileAppSettings", {
      method: "GET",
      requireAuth: true,
    });
  },

  verifySub(uid) {
    //: string
    return apiClient.request(`/api/verifySub/${uid}`, {
      method: "POST",
      requireAuth: true,
    });
  },
};
